export default __webpack_public_path__ + "static/media/white-icon.126aa97e.png";